export default __webpack_public_path__ + "static/media/press-release-september-2025.1fa3041c.pdf";